import request from '@/utils/request';

// 标签列表
export function translateList(data) {
  return request.post('admin/translate/list', data);
}
export function translateDetail(data) {
  return request.post('admin/translate/detail', data);
}
export function translateStore(data) {
  return request.post('admin/translate/store', data);
}
export function translateEdit(data) {
  return request.post('admin/translate/edit', data);
}
export function translateDelete(data) {
  return request.post('admin/translate/delete', data);
}